export class Lazy<T> {
  private cached: T = null;
  private factory: () => T;

  constructor(factory: () => T) {
    this.factory = factory;
  }

  getInstance(): T {
    if (this.cached) {
      return this.cached;
    }

    this.cached = this.factory();

    return this.cached;
  }
}
